export function binarySearch(array: any[], target: string | number | Date, key: string | null = null): number {

    let left = 0;
    let right = array.length - 1;
    let result = -1;

    while (left <= right) {
        const mid = (left + right) >> 1;

        const midValue = key ? array[mid][key] : array[mid];
        const compare = defaultComparator(midValue, target);

        if (compare === 0) {
            result = mid;     // on mémorise et on continue à gauche
            right = mid - 1;
        }

        if (compare < 0) {
            left = mid + 1;
        } else {
            right = mid - 1;
        }
    }

    return result;
}

export function lowerBound(array: any[], target: string | number | Date, key: string | null = null): number {
    let left = 0;
    let right = array.length;

    while (left < right) {
        const mid = (left + right) >> 1;
        const midValue = key ? array[mid][key] : array[mid];
        const compare = defaultComparator(midValue, target);
        if (compare < 0) {
            left = mid + 1;
        } else {
            right = mid;
        }
    }

    return left;
}
export function upperBound(array: any[], target: string | number | Date, key: string | null = null): number {
    let left = 0;
    let right = array.length;

    while (left < right) {
        const mid = (left + right) >> 1;
        const midValue = key ? array[mid][key] : array[mid];
        const compare = defaultComparator(midValue, target);
        if (compare <= 0) {
            left = mid + 1;
        } else {
            right = mid;
        }
    }

    return left;
}

export function defaultComparator(a: any, b: any) {
    // gestion des Date
    if (a instanceof Date && b instanceof Date) {
        return a.getTime() - b.getTime();
    }

    // number
    if (typeof a === "number" && typeof b === "number") {
        return a - b;
    }

    // string
    if (typeof a === "string" && typeof b === "string") {
        return a.localeCompare(b);
    }

    // fallback universel
    if (a > b) return 1;
    if (a < b) return -1;
    return 0;
}